<template>
  <div id="app">
    <main>
      <div class="top">
        <div class="content">
          <img
            height="60"
            @click="toIndex"
            src="http://imgcdn.lanxiongsports.com/upload/lanxiongsports/logo@2x_2.png"
            alt
            class="logo"
          >
          <img
            class="bg"
            src="http://imgcdn.lanxiongsports.com/upload/lanxiongsports/banner.png"
            alt
          >
        </div>
      </div>
      <div class="introduce">
        <p>2000年1月，在美国方言学会(American Dialect Society)
          <br>举行的一次评选中，“她”字一举战胜“科学”、“自由”和“正义”等，
          <br>成为“21世纪最重要的一个字”。
          <br>这称得上21世纪即“她时代到来”的引子。
          <br>&nbsp;
        </p>
        <p>时至今日，女性在商业和社会中的重要作用已无需赘言。
          <br>但在男性荷尔蒙浓厚的体育产业，女性角色却相对“失语”。她们是运动员、
          <br>高管、创业者、推动者……她们在体育产业不可或缺，
          <br>但是作为一个群体，她们的面貌却相对模糊。
          <br>&nbsp;
        </p>
        <p>有鉴于此，懒熊体育今年特别联合国际体育猎头公司SRI推出
          <br>“面孔：体育产业的女性力量”专题，
          <br>通过这些极具代表性的人物故事，折射体育产业的女性群体形象，
          <br>让体育产业听到女性的声音。
        </p>
      </div>
      <div class="m-introduce">
        <p>
          2000年1月，在美国方言学会(American
          <br>Dialect Society)
          举行的一次评选中，
          <br>“她”字一举战胜“科学”、“自由”和“正义”等，
          <br>成为“21世纪最重要的一个字”。
          <br>这称得上21世纪即“她时代到来”的引子。
          <br>&nbsp;
        </p>
        <p>时至今日，女性在商业和社会中的重要作用
          <br>已无需赘言。
          <br>但在男性荷尔蒙浓厚的体育产业，
          <br>女性角色却相对“失语”。她们是运动员、
          <br>高管、创业者、推动者……她们
          <br>在体育产业不可或缺，
          <br>但是作为一个群体，她们的面貌却相对模糊。
          <br>&nbsp;
        </p>
        <p>有鉴于此，懒熊体育今年特别联合
          <br>国际体育猎头公司SRI推出
          <br>“面孔：体育产业的女性力量”专题，
          <br>通过这些极具代表性的人物故事，
          <br>折射体育产业的女性群体形象，
          <br>让体育产业听到女性的声音。
        </p>
      </div>
      <div class="women-list">
        <ul>
          <li>
            <a href="http://www.lanxiongsports.com/?c=posts&a=view&id=14955" target="_blank">
              <img src="http://imgcdn.lanxiongsports.com/upload/lanxiongsports/pho_1_9.jpg" alt>
              <div class="intro">
                <div class="content">
                  <p>李娜</p>
                  <p>网球教会了我自律两个字</p>
                </div>
              </div>
            </a>
          </li>
          <li>
            <a href="http://lanxiongsports.com/posts/view/id/14949.html" target="_blank">
              <img src="http://imgcdn.lanxiongsports.com/upload/lanxiongsports/pho2.jpg" alt>
              <div class="intro">
                <div class="content">
                  <p>朱婷</p>
                  <p>态度就是我们的选择</p>
                </div>
              </div>
            </a>
          </li>
          <li>
            <a href="http://lanxiongsports.com/posts/view/id/14951.html" target="_blank">
              <img src="http://imgcdn.lanxiongsports.com/upload/lanxiongsports/pho3.jpg" alt>
              <div class="intro">
                <div class="content">
                  <p>赵峰</p>
                  <p>职场上越资深的级别越考量综合能力，与性别无关</p>
                </div>
              </div>
            </a>
          </li>
          <li>
            <a href="http://lanxiongsports.com/posts/view/id/14941.html" target="_blank">
              <img src="http://imgcdn.lanxiongsports.com/upload/lanxiongsports/pho_4_9.jpg" alt>
              <div class="intro">
                <div class="content">
                  <p>唐金</p>
                  <p>受再多伤也从来不后悔</p>
                </div>
              </div>
            </a>
          </li>
          <li>
            <a href="http://lanxiongsports.com/posts/view/id/14940.html" target="_blank">
              <img src="http://imgcdn.lanxiongsports.com/upload/lanxiongsports/pho_5_9.jpg" alt>
              <div class="intro">
                <div class="content">
                  <p>徐莉佳</p>
                  <p>影响女性的因素就是家庭</p>
                </div>
              </div>
            </a>
          </li>
          <li>
            <a href="http://lanxiongsports.com/posts/view/id/14950.html" target="_blank">
              <img src="http://imgcdn.lanxiongsports.com/upload/lanxiongsports/pho_6_9.jpg" alt>
              <div class="intro">
                <div class="content">
                  <p>马赟</p>
                  <p>女性会为体育行业带来更多的多样性及可执行力</p>
                </div>
              </div>
            </a>
          </li>
          <li>
            <a href="http://lanxiongsports.com/posts/view/id/14944.html" target="_blank">
              <img src="http://imgcdn.lanxiongsports.com/upload/lanxiongsports/pho7.jpg" alt>
              <div class="intro">
                <div class="content">
                  <p>跳跳</p>
                  <p>有一种好妈妈是活成自己孩子的榜样</p>
                </div>
              </div>
            </a>
          </li>
          <li>
            <a href="http://lanxiongsports.com/posts/view/id/14942.html" target="_blank">
              <img src="http://imgcdn.lanxiongsports.com/upload/lanxiongsports/pho8.jpg" alt>
              <div class="intro">
                <div class="content">
                  <p>龚蓓苾</p>
                  <p>体育给予我力量</p>
                </div>
              </div>
            </a>
          </li>
          <li class="more" @click="moreProject">
            <div class="mask"></div>
            <div class="blur"></div>
            <img
              class="pc"
              src="http://imgcdn.lanxiongsports.com/upload/lanxiongsports/more_1.jpg"
              alt
            >
            <img
              class="m"
              src="http://imgcdn.lanxiongsports.com/upload/lanxiongsports/m_more_1.jpg"
              alt
            >
            <div class="content">
              <div class="more-icon"></div>
              <p>更多懒熊专题</p>
            </div>
          </li>
        </ul>
      </div>
      <div class="more-projects">
        <ul>
          <li @click="relatedActivities">
            <img src="http://imgcdn.lanxiongsports.com/upload/lanxiongsports/act_1.jpg" alt>
            <div class="intro">
              <div class="content">
                <p>相关活动：2018女性运动产业高峰论坛</p>
              </div>
            </div>
          </li>
          <li class="more" @click="moreActivity">
            <div class="mask"></div>
            <!-- <div class="blur"></div> -->
            <img src="http://imgcdn.lanxiongsports.com/upload/lanxiongsports/more_2.jpg" alt>
            <div class="content">
              <div class="more-icon"></div>
              <p>更多懒熊活动</p>
            </div>
          </li>
        </ul>
      </div>
    </main>
    <common-footer/>
  </div>
</template>

<script>
import CommonFooter from '@/components/CommonFooter'
import { getWxConfig } from '@/utils/api'
export default {
  name: 'app',
  components: {
    CommonFooter
  },
  async mounted() {
    const url = window.location.href.split('#')[0]
    const params = {
      url
    }

    const res = await getWxConfig(params)
    window.wx.config({
      debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
      appId: 'wx4690a55401737a1f', // 必填，公众号的唯一标识
      timestamp: res.timestamp, // 必填，生成签名z 的时间戳
      nonceStr: res.nonceStr, // 必填，生成签名的随机串
      signature: res.signature, // 必填，签名
      jsApiList: [
        'onMenuShareAppMessage',
        'onMenuShareTimeline',
        'scanQRCode',
        'chooseWXPay'
      ] // 必填，需要使用的JS接口列表
    })

    window.wx.ready(() => {
      // const _url = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${this.appId}&redirect_uri=https://ar.lanxiongtiyu.com/ar_api/v1/wx/opLogin.do?redirectUrl=${window.location.origin}&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect`
      // const link = `${window.location.origin}/redirect?redirectUrl=${_url}`
      const timeLineConf = {
        title: '面孔:体育产业的女性力量', // 分享标题
        link: url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        imgUrl: 'http://imgcdn.lanxiongsports.com/2019womensday_thumb.jpg', // 分享图标
        success() {
        }
      }

      const friendsConf = {
        title: '面孔:体育产业的女性力量', // 分享标题
        // desc: this.activityDetail.lecturerInfo.intro, // 分享描述
        link: url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        imgUrl: 'http://imgcdn.lanxiongsports.com/2019womensday_thumb.jpg', // 分享图标
        desc: '懒熊体育2019年“三八妇女节”专题',
        type: '', // 分享类型,music、video或link，不填默认为link
        dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
        success() {
        }
      }
      console.log(window.wx)
      console.log(friendsConf, timeLineConf)
      window.wx.onMenuShareTimeline(timeLineConf)
      window.wx.onMenuShareAppMessage(friendsConf)
    })
  },
  methods: {
    toIndex() {
      window.open('http://lanxiongsports.com');
    },
    relatedActivities() {
      window.open('http://lanxiongsports.com/posts/view/id/12194.html')
    },
    moreActivity() {
      window.open('http://lanxiongsports.com/huodong/index.html')
    },
    moreProject() {
      window.open('http://www.lanxiongsports.com/posts/view/id/5546.html')
    }
  }
}
</script>

<style lang="scss" src="./App.scss">
</style>
